<script lang="ts">
    import {MenuItem} from '@rgossiaux/svelte-headlessui';
    import {exists} from 'shared/utils/custom-utils';

    export let isDisabled = false;
    export let showWhen = true;
    export let dataQa: string | null = null;
    export let additionalClasses = '';
    export let href: string | null = null;

    $: href = isDisabled || !exists(href) ? 'javascript:void(0)' : href;
</script>

{#if showWhen}
    <MenuItem as="li">
        {#if isDisabled}
            <a {href} class="{additionalClasses}" data-qa="{dataQa}">
                <slot/>
            </a>
        {:else}
            <a {href} class="{additionalClasses}" data-qa="{dataQa}" on:click>
                <slot/>
            </a>
        {/if}
    </MenuItem>
{/if}